module.exports = (__webpack_require__(4))(1728);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-router-redux/es/index.js from dll-reference vendorProd_library
// module id = 654
// module chunks = 42